import { request } from '@/shared/api/request'

export const getTradeUnionList = (params) => {
	return request({ url: 'colcontract/tradeUnion/page', method: 'POST', params })
}
